import ReactRailsUJS from 'react_ujs'
import { onTurboPageUpdate } from './turbo_page'

export const setupReactRails = () => {
  const modules = import.meta.glob('../components/**/*.jsx', { eager: true })
  const components = {}

  Object.keys(modules).forEach(path => {
    const relativePath = path.replace('../components/', '')
    const module = modules[path]
    const defaultExport = module.default ?? module

    components[`./${relativePath}`] = defaultExport
    components[`./${relativePath.replace(/\.jsx$/, '')}`] = defaultExport
  })

  const requireContext = key => components[key]
  requireContext.keys = () => Object.keys(components)

  ReactRailsUJS.useContext(requireContext)

  /*
   * react_ujs only auto-detects Turbolinks / native DOMContentLoaded — not Turbo.
   * Mount after every Drive render/load. Form error responses (e.g. Devise 422)
   * fire turbo:render without turbo:load.
   */
  const mount = () => {
    ReactRailsUJS.mountComponents()
  }

  const unmount = () => {
    ReactRailsUJS.unmountComponents()
  }

  document.addEventListener('turbo:before-render', unmount)
  document.addEventListener('turbo:before-cache', unmount)
  onTurboPageUpdate(mount)
  document.addEventListener('turbo:frame-load', mount)
}
